import { render, staticRenderFns } from "./InvestmentsSympatia.vue?vue&type=template&id=6de024ba&scoped=true"
import script from "./InvestmentsSympatia.vue?vue&type=script&lang=js"
export * from "./InvestmentsSympatia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de024ba",
  null
  
)

export default component.exports